import { ferryFetch } from '../../common/request';
import { querystringify } from '../../common/utils';
interface UserInfo {
  avatar_url: string;
  name: string;
}
export interface SharePageData {
  invite_code: string;
  user_info: UserInfo;
  landing_download_url: string;
  marquee_list: {
    id: string;
    take_cash_amount: string;
    name: string;
    avatar_url: string;
  }[];
  share_info: {
    content_map: {
      [k: string]: string;
    };
    image_url_map: {
      [k: string]: string;
    };
    total_amount: {
      [k: string]: string;
    };
  };
  video_info?: VideoInfo;
}
interface Tag {
  Id: string;
  Title: string;
}
interface Music {
  Title: string;
  CoverThumb: {
    UrlList: string[];
  };
}
export interface VideoInfo {
  cover: {
    UrlList: string[];
  };
  title: string;
  username: string;
  avatar_url: string;
  tag: Tag[];
  video_url: {
    UrlList: string[];
  };
  music: Music;
}
interface ShareParam {
  u_code: string;
  aid: string;
  carrier_region: string;
  activity_type: number;
  item_id?: string;
}
export interface ShareResponse {
  data?: SharePageData;
  err_no: number;
  err_tips?: string;
}
export const getShareInfo = (params: ShareParam) => {
  return ferryFetch(`${window.location.origin}/luckycat/tiktokm/v1/relation/share_page?${querystringify(((params as unknown) as Record<string, string | number>))}`).then(data => {
    return (data as ShareResponse);
  });
};